import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BulkInviteStudentResponse, BulkInviteTeacherResponse, ValidateTemplateResponse } from '@edtech-ui/core/models/admin-panel/bulk-invite.model';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BulkInviteService {
  baseUrl = environment.adminDashboardUrl;
  endpoints = environment.adminDashboardEndpoints;
  constructor(private http: HttpClient) { }

  validateTemplate(headers: string[], userType: 'teacher' | 'student') {
    const url = `${this.baseUrl}${this.endpoints.validateTemplate}/${userType}/validate`;
    return this.http.post<ValidateTemplateResponse>(url, headers, {
      headers: { 'Content-Type': 'application/json' }
    });
  }

  bulkInviteTeachers(file: File): Observable<BulkInviteTeacherResponse> {
    const formData = new FormData();
    formData.append('file', file);
    const url = `${this.baseUrl}${this.endpoints.bulkInviteTeachers}`;
    return this.http.post<BulkInviteTeacherResponse>(url, formData);
  }

  bulkInviteStudents(file: File): Observable<BulkInviteStudentResponse> {
    const formData = new FormData();
    formData.append('file', file);
    const url = `${this.baseUrl}${this.endpoints.bulkInviteStudents}`;
    return this.http.post<BulkInviteStudentResponse>(url, formData);
  }
}
